export const getArcPhotoImageProxy = (photo, size = 'thumbnail') => {
  const proxyBase = process.env.REACT_APP_ARC_PHOTO_PROXY_URL;

  const resizerPath = size === 'thumbnail' ? photo?.additional_properties?.thumbnailResizeUrl : photo?.additional_properties?.fullSizeResizeUrl;

  if (resizerPath && resizerPath.includes('resizer/v2')) {
    return `${proxyBase}${resizerPath}`;
  }

  if (!photo?._id) {
    return '';
  }

  const extension = photo?.url?.split('.')?.pop() || 'jpg';

  return `${proxyBase}/resizer/v2/${photo._id}.${extension}`;
};
